export default [
  {
    path: 'additional-exam',
    name: 'additional-exam',
    component: () => import('@/views/pages/additional-exam/AdditionalExam.vue'),
    redirect: { name: 'additional-exam-list' },
    children: [
      {
        path: '',
        name: 'additional-exam-list',
        component: () => import('@/views/pages/additional-exam/List.vue'),
        meta: {
          pageTitle: 'Additional exams',
          breadcrumb: [
            {
              text: 'Additional exams',
              active: true,
            },
          ],
          resource: 'AdditionalExam',
        },
      },
      {
        path: ':id',
        name: 'additional-exam-view',
        component: () => import('@/views/pages/additional-exam/View.vue'),
        meta: {
          pageTitle: 'Additional exams',
          breadcrumb: [
            {
              to: { name: 'additional-exam' },
              text: 'Additional exams',
              active: false,
            },
            {
              text: 'view',
              active: true,
            },
          ],
          resource: 'AdditionalExam',
        },
      },
    ],
  },
]
